'use strict';

var d3 = require('d3');
var _ = require('lodash');
var drawUtils = require('../utils/drawUtils');

var D3W = { inititiated: false };

D3W.updateWarnings = function (_g, wData, environment) {
  D3W.environment = environment;
  var offsetW = 0;
  var offsetY = wData.length > 0 ? wData[0].y : 0;
  if (!D3W.inititiated && wData.length > 0) {
    offsetW = 72;
    D3W.inititiated = true;
  }

  d3.selectAll("#validationWarnings").remove(); // clear first all current warnings

  var validationWarnings = _g.selectAll('#validationWarnings').data(wData, function (d, i) {
    return d.warning;
  });

  var lastYPos = offsetY;
  validationWarnings.enter().append('g').attr('id', 'validationWarnings').each(function (d, i) {
    var g = d3.select(this);

    var bckgrWarning = g.append('rect');
    bckgrWarning.attr('id', 'background-warning')
    // .attr('width', d.x + "px")
    // .attr('height', d.h + "px")
    .attr('fill', '#fff').attr('rx', 3).attr('ry', 3);

    var bckgrWarningOutline = g.append('rect');
    bckgrWarningOutline.attr('id', 'background-warning-outline')
    // .attr('width', d.x + "px")
    // .attr('height', d.h + "px")
    .attr('fill', 'none').attr('stroke', '#000').attr('stroke-opacity', 0.25).attr('stroke-width', 0.15).attr('rx', 3).attr('ry', 3);

    g.append('rect').attr('id', 'signal-warning').attr('x', 0.5).attr('width', 4).attr('height', d.h).attr('fill', drawUtils.colors.signals.warningHigh).attr('rx', 1).attr('ry', 1);

    var iconPos = { x: 8, y: 6 };

    var fObject = g.append('svg:foreignObject').attr("width", 28).attr("height", 28).attr('x', iconPos.x).attr('y', iconPos.y);

    var label = fObject.append("xhtml:div").style('cursor', 'default').style('background-color', '#fff').style('color', drawUtils.colors.signals.warningHigh).html(function () {
      var icon = '<i class="iconfont-dls-16"></i>';
      if (D3W.environment === 'ISPM') icon = '<i class="icon__ExclamationCircle iconfont-dls-16"></i>';
      return icon;
    });

    var textNode = g.append('text');
    textNode.attr('id', 'validation-label').attr('x', 28).attr('y', 18)
    // .attr('width', 100)
    .attr('fill', drawUtils.colors.signals.warningHigh).attr('font-size', 14).attr('font-weight', 500).text(function (d) {
      return d.warning;
    });

    lastYPos = D3W.computeBounds(g, textNode, offsetW, lastYPos, [bckgrWarning, bckgrWarningOutline]);

    //D3W.updateWarnings(_g, wData, environment);
  });

  lastYPos = offsetY;
  validationWarnings.transition().duration(500).each(function (d) {
    var g = d3.select(this);
    var textNode = g.select('#validation-label');
    textNode.text(function (d) {
      return d.warning;
    });

    lastYPos = D3W.computeBounds(g, textNode, 0, lastYPos, [g.select('#background-warning'), g.select('#background-warning-outline')]);
  });

  validationWarnings.exit().remove();
};

D3W.computeBounds = function (g, textNode, offsetW, offsetY, alignElements) {

  // show max-height and wrap text if width exceeds it
  var clientRect = drawUtils.computeTextNodeRect(textNode, offsetW + 32, 280, alignElements);

  g.select('#signal-warning').attr('height', clientRect.height);

  g.attr("transform", function (d) {
    return "translate(" + d.x + "," + offsetY + ")";
  });

  // return the Y position for the next element
  return offsetY += clientRect.height + 3;
};

module.exports = D3W;